import { FC, TdHTMLAttributes } from "react";
import { Cell, flexRender } from "@tanstack/react-table";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type TableCellProps = TdHTMLAttributes<HTMLTableCellElement> & {
  cell?: Cell<object, unknown>;
}

export const TableCell: FC<TableCellProps> = (({ cell, ...props }) => {
  const content = cell ? flexRender(
    cell.column.columnDef.cell,
    cell.getContext(),
  ) : null;

  const cellProps = cell?.column?.columnDef.meta?.getCellProps?.(cell);

  return (
    <td
      {...props}
      {...cellProps}
      style={{
        ...props?.style,
        ...cellProps?.style,
      }}
      className={classNames(styles.root, cellProps?.className, props.className)}
    >
      {content}
    </td>
  );
});